import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_SpecimenCollectionDrugTestingConsentForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_SpecimenCollectionDrugTestingConsentForm' className='file-pdf-document'>
            <div className='file-template'>
<p className='w-750'><h3>SPECIMEN COLLECTION AND DRUG TESTING CONSENT FORM
                </h3>
                </p>
                
                <h4>Procedure Prior to Collection:
                </h4>
                <p className='w-750'>
                    Prior to any specimen collection procedure, secure the collection area and if necessary, perform
                    a thorough search for hidden adulterants or substitute urine specimens. Place bluing agent in
                    the toilet bowl or tank, remove or secure all chemicals (soaps, cleaning supplies, etc.) and
                    secure or eliminate all water sources.
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Check the identity of the donor (e.g. social security number or driver`s license number
                            and photo I.D.). If using a drug screen test requisition form, note the identity on the
                            form.
                        </li>
                        <li>Ask the donor to remove any unnecessary outer clothing such as coats, jackets and hats
                            etc... All personal belongings should be placed in a secure location outside the restroom
                            or partitioned area.
                        </li>
                        <li>Do not ask the donor to remove articles of clothing such as shirts, pants, dresses, etc. If
                            a collector notices any unusual behavior that indicates a donor may attempt to tamper
                            with or adulterate a specimen (e.g., bulging pockets), the collector may request that the
                            donor empty his/her pockets and explain the need for such items during collection.
                        </li>
                        <li>Prior to collection, ask the donor to wash his/her hands to eliminate any possible
                            adulterating or contaminating substances from under the donor's fingernails.
                        </li>
                    </ul>
                </p>
                <h4>Urine Collection Procedure:
                </h4>
                <p className='w-750'>
                    <ul>
                        <li>Place the following information on the bottle label:
                            <ol type="a">
                                <li>Date of the collection
                                </li>
                                <li>Donor`s name and/or identification numbers
                                </li>
                                <li>Collector`s initials.
                                </li>
                            </ol>
                        </li>
                        <li>Provide the donor with a clean, unused urine specimen collection container and instruct
                            the donor to fill the container at least half full (a minimum of 30 mL`s). For DOT samples
                            a minimum of 45 mL`s required.
                        </li>
                        <li>
                            <b>Unobserved Collection:</b>Allow the donor to enter and maintain privacy within the stall or
                            partitioned area. The collector will wait outside the collection area until the donor is
                            finished urinating. Complete the remainder of the test request form while the donor is
                            collecting the specimen.
                        </li>
                        <li>
                            <b>Observed Collection:</b>Inform the donor that collection will occur under direct
                            observation. Accompany the donor into the collection facility (the collector must be the
                            same gender). Instruct the donor to urinate into the sample container with the witness
                            observing urination. Complete the remainder of the test request form after the donor
                            has completed collecting the specimen.
                        </li>
                        <li>Accept the specimen from the donor. The use of disposable gloves is required when
                            handling specimens.
                        </li>
                        <li>Upon receipt of the specimen from the donor, immediately apply the temperature strip
                            (if applicable) to the outside of the bottle. If using a drug screen test request form,
                            record the urine temperature on the form.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    NOTE: Urine temperature should be measured within (4) four minutes of collection and
                    should read between 90-100 F. If the temperature of the urine sample is not at the
                    designated temperature, than another sample may be required. If the donor and/or
                    parents or legal guardians have any questions or concerns, please address them with
                    your therapist.
                </p>
                <p className='w-750'>
                    <span className='small'>I, the undersigned, hereby knowingly and voluntarily authorize and consent to the collection and testing of specimens of my urine
                        by a collection site and laboratory to be designated by <b>Amethyst Consulting & Treatment Solutions, PLLC</b> or its designated
                        agent, for the purpose of drug testing.
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>I authorize the collection site, laboratory and medical review officer (MRO) to disclose the results of my drug tests to <b>Amethyst
                        Consulting & Treatment Solutions.
                    </b>
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>I acknowledge that the drug test results will be utilized by <b>Amethyst Consulting & Treatment Solutions, PLLC</b> to develop and
                        modify my Person-Centered Treatment plan as needed and report to referral sources for Coordination of Care.
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>I acknowledge that at the time of collection, a refusal to authorize the collection and testing of my urine by the collection site and
                        laboratory, or a refusal to authorize the above disclosure of the test results will be treated as "Non-compliance" with the program.
                        I further understand and acknowledge that my refusal to provide a urine sample will result in the reporting of my non-compliance
                        with the program to the referral source.
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>In addition, I hereby knowingly and voluntarily release <b>Amethyst Consulting & Treatment Solutions</b>, the collection site, the
                        testing laboratory and their respective officers, directors, employees and agents from any and all claims, damages, losses,
                        liabilities, costs and expenses, including attorney fees, arising from or relating to such collection and testing and any disclosure of
                        the results thereof, including without limitation, the disclosure of any inaccurate or incomplete results, to the fullest extent
                        permitted by law.
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>I further authorize the testing laboratory to disclose the results of my drug screen to <b>Amethyst Consulting & Treatment Solutions</b>,
                        PLLC, or its agents, for a period of time not to exceed one (1) year from the date of my signature below.
                    </span>
                </p>
                <p className='w-750'>
                    <span className='small'>I acknowledge that I have the right to receive a copy of this authorization and by signing this form I am giving my child or ward
                        permission, which will be providing the urine specimen to sign off on the requisition form and their signature is deemed valid and
                        admissible. I have read and understood the above Authorization & Consent in its entirety, and I agree that a copy of this
                        document is as valid as the original.
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>
                            Client/Responsible Party Signature:
                        </td>
                        <td className='small w-250'>
                            Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>
                            Amethyst Representative Signature:
                        </td>
                        <td className='small w-250'>
                            Date:
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
